import React from 'react'
import BooksitoutIcon from '../../config/BooksitoutIcon'
import booksitoutIcon from '../../config/BooksitoutIcon'
import useLoginStore from '../login/useLoginStore'
import { BookStatus } from './BookType'
import styled from 'styled-components'
import ColorConfig from '../../config/ColorConfig'

const BookAddBadge: React.FC<{ bookStatus: BookStatus; onClick: () => void }> = ({ bookStatus, onClick }) => {
	const isLoggedIn = useLoginStore(state => state.isLoggedIn())

	if (bookStatus == 'NOT_ADDED') {
		if (isLoggedIn) {
			return (
				<Badge color={'gray'} className={'clickable'} onClick={onClick}>
					<BooksitoutIcon.add />
					<span className={'ps-1'}>서재에 추가</span>
				</Badge>
			)
		} else {
			return (
				<a href={'/login'}>
					<Badge color={'gray'} className={'clickable'}>
						<BooksitoutIcon.add />
						<span className={'ps-1'}>서재에 추가</span>
					</Badge>
				</a>
			)
		}
	}

	if (bookStatus == 'NOT_STARTED') {
		return (
			<Badge color={ColorConfig.Primary}>
				<BooksitoutIcon.check />
				<span>추가됨</span>
			</Badge>
		)
	}

	if (bookStatus == 'READING') {
		return (
			<Badge color={ColorConfig.Primary}>
				<PulsingDot />
				<span>읽는 중</span>
			</Badge>
		)
	}

	if (bookStatus == 'DONE') {
		return (
			<Badge color={ColorConfig.Primary}>
				<booksitoutIcon.check />
				<span>다 읽음</span>
			</Badge>
		)
	}

	if (bookStatus == 'GIVE_UP') {
		return (
			<Badge color={ColorConfig.Danger}>
				<span>포기</span>
			</Badge>
		)
	}

	return <></>
}

const Badge = styled.span<{ color: string }>`
	display: flex;
	align-items: center;
	gap: 5px;

	background: ${props => props.color};
	color: white;
	padding: 5px 14px;
	border-radius: 8px;
	font-size: 15px;
	font-weight: 600;
	text-transform: uppercase;
`

const PulsingDot = styled.div`
	width: 8px;
	height: 8px;
	background: white;
	border-radius: 50%;
	animation: pulse 2s infinite;

	@keyframes pulse {
		0%,
		100% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
	}
`

export default BookAddBadge
